import { CASH_CONVERSION_FEE } from '@/constants'
import { IS_TESTNET } from '@/constants/walletConnectionConfig'
import Decimal from 'decimal.js'

interface SwapInfo {
  fromTokenAmount?: string | number
  toTokenAmount?: string | number
}

interface SwapTokenBalanceData {
  sellTokenBalance?: string | number
}

interface UseCashToTokenCalculationsProps {
  amount?: string | number
  sechAmount?: string | number
  swapInfo: SwapInfo
  swapTokenBalanceData: SwapTokenBalanceData
}

export const useCashToTokenCalculations = ({
  amount = 0,
  sechAmount,
  swapInfo,
  swapTokenBalanceData
}: UseCashToTokenCalculationsProps) => {
  const amountDecimal = new Decimal(amount || 0)

  const feeAmount = amountDecimal
    .mul(CASH_CONVERSION_FEE)
    .div(100)
    .toDecimalPlaces(2, Decimal.ROUND_DOWN)

  const netAmount = amountDecimal
    .sub(feeAmount)
    .toDecimalPlaces(2, Decimal.ROUND_DOWN)

  const exchangeRate = new Decimal(swapInfo?.fromTokenAmount || 0)
    .div(new Decimal(swapInfo?.toTokenAmount || 1))
    .toDecimalPlaces(4, Decimal.ROUND_DOWN)

  const userReceive = new Decimal(sechAmount || 0).toDecimalPlaces(
    4,
    Decimal.ROUND_DOWN
  )

  const decimalPlaces = IS_TESTNET ? 18 : 2

  const adminSpend = new Decimal(
    swapInfo?.fromTokenAmount || 0
  ).toDecimalPlaces(decimalPlaces)

  const adminBalance = new Decimal(
    swapTokenBalanceData?.sellTokenBalance || 0
  ).toDecimalPlaces(decimalPlaces)

  const isBalanceInsufficient =
    !!sechAmount &&
    new Decimal(swapInfo?.fromTokenAmount || 0).greaterThan(
      new Decimal(swapTokenBalanceData?.sellTokenBalance || 0)
    )

  return {
    feeAmount: feeAmount.toString(),
    netAmount: netAmount.toString(),
    exchangeRate: exchangeRate.toString(),
    userReceive: userReceive.toString(),
    adminSpend: adminSpend.toString(),
    adminBalance: adminBalance.toString(),
    isBalanceInsufficient
  }
}
